<template>
    <div class="TQ_center">

        <!-- Events -->
        <tq-card width="100%" max-width="1200px" margin="16px" padding="12px">

            <tq-calendar-big
                :p_system_lang-code_s="store_system_langCode_v.val"
                :p_events_by-day-time_a="co_calendarEvents_byDayTime_a"

                :p_show-create-new-event_b="co_displayCreateEventBtn_b"

                :pe_on-click-day_f="m_userEvent_newEvent_f"
                :pe_on-change-month_f="m_changeDisplayMonth_f"
            />

        </tq-card>

        <!-- Add Quest Event Popup-->
        <tq-popup :show="popup_newQuestEvent_o.show_vb"
                  padding="0px"
                  max-width="700px"
                  :show-close-btn="true" >

            <!-- Title -->
            <div class="TQ_bg_purple_dark TQ_borderRadius_top TQ_margin_bottom_8px TQ_padding_12px TQ_text_32px">
                {{ass_strings.fourWords_createNewQuestEvent[store_system_langCode_v.val]}}
            </div>

            <!-- Date -->
            <div class="TQ_margin_8px TQ_text_24px">{{format_date_YYYY_MM_DD_fs(popup_newQuestEvent_o.date_t)}}</div>

            <!-- Select Quest Explore-->
            <div class="TQ_maxWidth_400px TQ_center">
                <div class="TQ_align_initial TQ_text_underline TQ_text_bold  TQ_textColor_purple">
                    {{ass_strings.oneWord_quest[store_system_langCode_v.val]}}
                </div>
                <tq-dropdown :style-select="true" class="TQ_width_100p TQ_margin_bottom_8px TQ_text_24px"
                             :p_show-search-bar_b="obj_size_fn(server_questsExplore_byQuestId) > gv_numbers.dropdown_showSearchBar_minRows"
                             :p_system-lang-code_e="store_system_langCode_v.val"
                             :pe_update-search_f="(searchVal) => {newEvent_chooseQuest_searchVal_s=searchVal}">

                    <div slot="select">
                        <div v-if="popup_newQuestEvent_o.questExplore_c">
                            {{popup_newQuestEvent_o.questExplore_c.qex_name_byLangCode_s[popup_newQuestEvent_o.questExplore_c.cm_qex_getDisplayLang_fe(store_system_langCode_v.val)]}}
                        </div>
                    </div>

                    <div slot="options"
                         @click="m_chooseNewQuestEvent_f(questExplore_c)"
                         v-for="questExplore_c in co_chooseableDate_questsExplore_ac">
                        {{questExplore_c.qex_name_byLangCode_s[questExplore_c.cm_qex_getDisplayLang_fe(store_system_langCode_v.val)]}}
                    </div>

                </tq-dropdown>
            </div>

            <!-- Select starting date-->
            <div class="TQ_maxWidth_400px TQ_center">
                <div class="TQ_align_initial TQ_text_underline TQ_text_bold TQ_textColor_purple">
                    {{ass_strings.oneWord_hour[store_system_langCode_v.val]}}
                </div>
                <input type="time" class="TQ_margin_bottom_8px TQ_input TQ_text_20px TQ_padding_4px TQ_width_100p TQ_borderBox" v-model="popup_newQuestEvent_o.hour_s">
            </div>

            <!-- select clock type -->
            <div class="TQ_maxWidth_400px TQ_center">
                <div class="TQ_align_initial TQ_text_underline TQ_text_bold TQ_textColor_purple">
                    {{ass_strings.threeWords_startClockType[store_system_langCode_v.val]}}
                </div>
                <div class="TQ_grid_col_1frAuto">
                    <tq-dropdown :style-select="true" class="TQ_width_100p TQ_text_20px TQ_grid_verticalCenter" >
                        <div slot="select" class="TQ_padding_4px " >
                            <div v-if="popup_newQuestEvent_o.stackClockType_e">
                                {{format_clockType_f(popup_newQuestEvent_o.stackClockType_e, store_system_langCode_v.val)}}
                            </div>
                            <div v-else>
                                -
                            </div>
                        </div>

                        <div slot="options"
                             class="TQ_text_20px"
                             @click="popup_newQuestEvent_o.stackClockType_e = startClockType_e"
                             v-for="startClockType_e in enum_questEventStartClockTypes_s">
                            {{format_clockType_f(startClockType_e, store_system_langCode_v.val)}}
                        </div>
                    </tq-dropdown>

                    <tq-more-info :p_more-info-id_uid="enum_moreInfoIds_s.helpers_event_clock_types"
                                  class="TQ_width_24px TQ_grid_verticalCenter TQ_margin_4px "/>
                </div>


            </div>
            <hr>

            <!-- event name and image by lang code -->
            <div class="TQ_minHeight_100px">

                <div v-if="popup_newQuestEvent_o.questExplore_c">
                    <div  v-for="langCode in popup_newQuestEvent_o.questExplore_c.qex_langArr_ae"
                          class="TQ_margin_bottom_16px TQ_inline TQ_margin_8px ">

                        <div class="TQ_text_20px TQ_text_bold">{{format_langCode_fs(langCode)}} </div>

                        <div class="TQ_border TQ_padding_8px TQ_box_shadow ">

                            <!-- event name -->
                            <div :style="{'direction' : helper_getDirectionByLangCode_fe(langCode)}">
                                <div
                                        class="TQ_align_initial TQ_text_underline TQ_text_bold TQ_textColor_purple">
                                    {{ass_strings.twoWords_eventName[langCode]}}
                                </div>
                                <input class="TQ_margin_bottom_8px TQ_input TQ_width_100p TQ_borderBox TQ_maxWidth_300px TQ_text_20px"
                                       :placeholder="ass_strings.twoWords_eventName[langCode]"
                                       v-model="popup_newQuestEvent_o.name_byLangCode_s[langCode]"/>
                            </div>

                            <div>

                                <!-- lang name -->
                                <div  :style="{'direction' : helper_getDirectionByLangCode_fe(langCode)}"
                                      class="TQ_align_initial TQ_text_underline TQ_text_bold TQ_textColor_purple">
                                    {{ass_strings.twoWords_eventImage[langCode]}}
                                </div>

                                <!-- image -->
                                <tq-img-fill-blur @click.native="m_chooseFileFromDrive_f(langCode)" p_height_s="180px"
                                                  class="TQ_clickable TQ_border TQ_borderBox"
                                                  p_max-width_s="300px"
                                                  :pp_img-url_s="popup_newQuestEvent_o.imageFile_blc_c[langCode].fi_url_s"/>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="TQ_margin_bottom_2px">

            <!-- Buttons -->
            <div class="TQ_grid_col_Auto1frAuto TQ_padding_8px TQ_text_20px">
                <div class="TQ_btn TQ_margin_4px TQ_borderRadius TQ_bg_red" @click="popup_newQuestEvent_o.show_vb.val = false">
                    {{ass_strings.oneWord_cancel[store_system_langCode_v.val]}}
                </div>
                <div></div>
                <tq-btn-approve
                        class="TQ_btn TQ_margin_4px TQ_bg_green TQ_borderRadius"
                        :system-lang-code="store_system_langCode_v.val"
                        :text="ass_strings.twoWords_createEvent"
                        :popup-text="ass_strings.question_createEvent"
                        :approve-cb="m_userEvent_createQuestEvent_f"/>
            </div>

        </tq-popup>

        <!-- choose file-->
        <tq-popup :show="showPopUpDrive_vb" width="100%" p_height_s="100vh" class="TQ_center" padding="0" :show-close-btn="true">
            <fcuc-drive
                :p_can-choose-video_b="false"
                :p_can-choose-audio_b="false"
                :pe_choose-file_f="m_chooseFile_f"
            />
        </tq-popup>

    </div>
</template>

<script>
    import {
        enum_langCodes, enum_moreInfo_helpersIds_s,
        enum_questEventStartClockTypes_s, enum_questPermission_n,
        enum_screenSizesOptions_n,
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import TqCard from '../../../components/basic/TqCard'
    import {
        server_questEvent_create_f,
        server_questEvents_cl_set_f,
        server_questEvents_cl_remove_f,
        serverPre_userDataSub_questPermission_get_withUserId_f
    } from "../../../scripts/Server/S_ServerPre";
    import {store_var, store_getStateValue_vo, store_setStateValue} from "../../../store";
    import {route_moveToRoute} from "../../../router";
    import {date_newDate_fd} from "../../../scripts/S_Date";
    import {Cla_CalendarEvent} from "../../../classes/TqClasses";
    import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {serverBig_questExplore_once_f} from "../../../scripts/Server/S_ServerFirestore";
    import TqPopup from "../../../components/basic/TqPopup";
    import TqDropdown from "../../../components/basic/TqDropdown";
    import TqBtnApprove from "../../../components/basic2/TqBtnApprove";
    import {ass_img_add_w} from "../../../assets/scripts/Ass_Files";
    import {
        format_clockType_f,
        format_date_input_fs,
    } from "../../../../functions/src/shareCode/Share_S_Format";
    import {obj_deepCopy_f, obj_forEach_f, obj_size_fn, obj_mapValues_fo} from "../../../../functions/src/shareCode/Share_S_Obj";
    import TqSelectImage from "../../../components/mediaComponenets/TqSelectImage";
    import {format_langCode_fs, format_date_YYYY_MM_DD_fs} from "../../../../functions/src/shareCode/Share_S_Format";
    import { enum_moveToOptions} from "../../../../functions/src/shareCode/Share_S_Enum";
    import TqCalendarBig from "../../../components/basic/TqCalendarBig";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f
    } from "../../../scripts/Server/S_ServerAuth";
    import {gv_numbers} from "../../../../functions/src/shareCode/Share_Ass_GlobalVirables";
    import {helper_getDirectionByLangCode_fe} from "../../../scripts/S_Helper";
    import {notification_notify} from "../../../scripts/S_Notification";
    import TqMoreInfo from "../../../components/basic2/TqMoreInfo";
    import {date_get0am_t} from "../../../../functions/src/shareCode/Share_S_Date";
    import TqDisplayFile from "@/components/mediaComponenets/TqDisplayFile";
    import TqImage from "@/components/basic/TqImage";
    import TqImgFillBlur from "@/components/basic2/TqImgFillBlur";
    import FcucDrive from "@/components/unpure/FcucDrive";

    export default {
        name: "V_Creator_Events_List",
        components:{
            FcucDrive,
            TqImgFillBlur,
            TqImage,
            TqDisplayFile,
            TqMoreInfo,
            TqCalendarBig,
            TqSelectImage,
            TqBtnApprove,
            TqDropdown,
            TqPopup,
            TqCard,
        },
        data(){
            return {

                calendarSelectedQuestId_a       : [],

                showPopUpDrive_vb : {val : false},

                // ==== create quest event ===
                popup_newQuestEvent_o : {
                    stackClockType_e    : null,
                    show_vb             : {val : false},
                    date_t              : null,
                    hour_s              : null,
                    name_byLangCode_s   : null,
                    imageFile_blc_c     : {},
                    questExplore_c      : null,
                    selectedDriveLangCode_e : null,
                },

                currentMonthDate_d              : date_newDate_fd(),
                questEventsListenersInfo_a      : [],
                newEvent_chooseQuest_searchVal_s: "",

                // === store ===
                store_system_langCode_v         : store_getStateValue_vo(store_var.system_langCode),
                store_system_windowSizeType_ve  : store_getStateValue_vo(store_var.system_windowSizeType_e),

                // === server ===
                server_currentUserData_c                : undefined,
                server_uds_questPermissions_byId_c      : {},
                server_questEvents_byEventId            : {},
                server_listenToQuestEvents_byQuestId    : {},
                server_questsExplore_byQuestId          : {},

                // === helpers ===
                obj_size_fn                 : obj_size_fn,
                ass_strings                 : ass_strings,
                ass_img_add_w               : ass_img_add_w,
                enum_windowSizeTypes        : enum_screenSizesOptions_n,
                enum_moreInfoIds_s        : enum_moreInfo_helpersIds_s,
                enum_questEventStartClockTypes_s        : enum_questEventStartClockTypes_s,
                format_langCode_fs          : format_langCode_fs,
                format_date_YYYY_MM_DD_fs   : format_date_YYYY_MM_DD_fs,
                helper_getDirectionByLangCode_fe   : helper_getDirectionByLangCode_fe,
                gv_numbers   : gv_numbers,
                format_clockType_f   : format_clockType_f,

            }
        },
        computed:{
            co_displayCreateEventBtn_b(){
                return this.server_currentUserData_c != null
                    && this.co_chooseableDate_questsExplore_ac.length > 0
            },
            co_chooseableDate_questsExplore_ac(){
                let ans = []

                for(let key in this.server_questsExplore_byQuestId){
                    ans.push(this.server_questsExplore_byQuestId[key])
                }

                return ans.filter(questExplore_c => {return questExplore_c.cm_qex_getName_fs(this.store_system_langCode_v.val).toLowerCase().includes(this.newEvent_chooseQuest_searchVal_s.toLowerCase())});
            },
            co_calendarEvents_byDayTime_a(){

                let ans = {}

                for(let questId in this.server_questEvents_byEventId){
                    let questEvent = this.server_questEvents_byEventId[questId]

                    if(questEvent == null){continue}
                    if(this.calendarSelectedQuestId_a.indexOf(questEvent.qev_questId_uid) === -1) {continue};

                    let startingDateDayTime_t = date_get0am_t(questEvent.qev_startingDate_t)

                    if(!ans[startingDateDayTime_t])
                        this.$set(ans, startingDateDayTime_t, [])

                    let newCalendarEvent = new Cla_CalendarEvent({
                        startingDate: questEvent.qev_startingDate_t,
                        endingDate: null,
                        title: questEvent.cm_qev_getName_fs(this.store_system_langCode_v.val) + ` (${questEvent.qev_playersNum_n})`,
                        clickCallback: this.m_userEvent_clickEvent_f,
                        key: questEvent.qev_eventId_uid,
                        backgroundColor: this.m_dom_getCalendarEventBackground_fs(questEvent),
                        color: 'white'
                    })

                    let index
                    for(index=0; index< ans[startingDateDayTime_t].length; index++){
                        let currentCalenderEvent = new Cla_CalendarEvent(ans[startingDateDayTime_t][index])

                        if(newCalendarEvent.startingDate < currentCalenderEvent.startingDate){
                            break;
                        }
                    }
                    ans[startingDateDayTime_t].splice(index,0, newCalendarEvent)
                };


                return ans

            },
        },
        methods:{

            // ===== dom =====
            m_dom_getCalendarEventBackground_fs(questEvent_c){
                let allCouponsApproved = true
                let atLastOneCouponApproved = false
                for(let couponId in questEvent_c.qev_ticketsStatus_byTicketId_b){
                    allCouponsApproved = allCouponsApproved && questEvent_c.qev_ticketsStatus_byTicketId_b[couponId]
                    if(questEvent_c.qev_ticketsStatus_byTicketId_b[couponId]){
                        atLastOneCouponApproved = true
                    }
                }
                if(allCouponsApproved)
                    return 'var(--color-green)'
                else if(atLastOneCouponApproved)
                    return 'var(--color-gold)'
                else
                    return 'var(--color-red)'
            },

            // ===== user events =====
            m_userEvent_clickEvent_f(calendarEvent_o){
                store_setStateValue(store_var.creator_events_selectedEvent_c, this.server_questEvents_byEventId[calendarEvent_o.key])
                route_moveToRoute(enum_moveToOptions.creator_events_item)
                // route_moveToRoute_withData_f(enum_moveToOptions.creator_events_item, this.server_questEvents_byEventId[calendarEvent_o.key])
            },

            // ===== popup =====
            m_userEvent_newEvent_f(dayDate_d){


                this.popup_newQuestEvent_o = {
                    stackClockType_e    : null,
                    show_vb             : {val : false},
                    date_t              : dayDate_d.getTime(),
                    hour_s              : null,
                    name_byLangCode_s   : null,
                    imageFile_blc_c     : {},
                    questExplore_c      : null,
                }



                this.popup_newQuestEvent_o.show_vb.val = true
            },
            m_chooseNewQuestEvent_f(questExplore_c){


                this.popup_newQuestEvent_o.questExplore_c       = questExplore_c
                this.popup_newQuestEvent_o.name_byLangCode_s    = obj_deepCopy_f(questExplore_c.qex_name_byLangCode_s)
                this.popup_newQuestEvent_o.imageFile_blc_c      = questExplore_c.qex_cm_getNewEventDisplayImg_blc_c()

            },
            m_userEvent_createQuestEvent_f(){

                if(this.popup_newQuestEvent_o.questExplore_c == null || this.popup_newQuestEvent_o.stackClockType_e == null || this.popup_newQuestEvent_o.hour_s == null){
                    notification_notify(ass_strings.oneWord_error, ass_strings.fourWords_pleaseFillAllFields)
                }

                let dateWithoutHours_s = format_date_input_fs(this.popup_newQuestEvent_o.date_t)
                let eventDate_t = (date_newDate_fd(dateWithoutHours_s + " " + this.popup_newQuestEvent_o.hour_s)).getTime()

                server_questEvent_create_f(
                    this.popup_newQuestEvent_o.questExplore_c,
                    this.popup_newQuestEvent_o.name_byLangCode_s ,
                    this.popup_newQuestEvent_o.imageFile_blc_c,
                    this.popup_newQuestEvent_o.stackClockType_e,
                    eventDate_t,
                )
                this.popup_newQuestEvent_o.show_vb.val = false

            },

            m_chooseFileFromDrive_f(langCode_e){
                this.showPopUpDrive_vb.val = true
                this.popup_newQuestEvent_o.selectedDriveLangCode_e = langCode_e
            },
            m_chooseFile_f(file_c){
                this.showPopUpDrive_vb.val = false
                this.popup_newQuestEvent_o.imageFile_blc_c[this.popup_newQuestEvent_o.selectedDriveLangCode_e] = file_c
            },

            // m_setDisplayMonthEvents_f
            m_setDisplayMonthQuestEvents_f(){

                this.currentMonthDate_d.setHours(0)
                this.currentMonthDate_d.setMinutes(0)
                this.currentMonthDate_d.setSeconds(0)
                this.currentMonthDate_d.setMilliseconds(0)

                let firstDayOfTheMonth_t = this.currentMonthDate_d.setDate(1)
                let lastDayOfTheMonth_t = date_newDate_fd(this.currentMonthDate_d.setMonth(this.currentMonthDate_d.getMonth()+1)).setDate(1)

                obj_forEach_f(this.server_uds_questPermissions_byId_c, uds_questPermission_c => {

                    this.questEventsListenersInfo_a.push({
                        uds_questPermission_c          : uds_questPermission_c,
                        firstDayOfTheMonth_t    : firstDayOfTheMonth_t,
                        lastDayOfTheMonth_t     : lastDayOfTheMonth_t,
                    })

                    // 3) get quest event
                    server_questEvents_cl_set_f(
                        this.$options.name,
                        uds_questPermission_c.udsqp_questType_e,
                        uds_questPermission_c.udsqp_questId_uid,
                        firstDayOfTheMonth_t,
                        lastDayOfTheMonth_t,
                        (questEvent_c) => {
                            this.$set(this.server_questEvents_byEventId, questEvent_c.qev_eventId_uid, questEvent_c)
                        },
                    )
                })
            },

            // m_changeDisplayMonth_f
            m_changeDisplayMonth_f(newMonth_d){
                this.currentMonthDate_d = newMonth_d
                this.m_setDisplayMonthQuestEvents_f()
            },

        },
        mounted(){
            // 1) get currentUserData
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData) => {

                if(currentUserData == null){return}

                this.server_currentUserData_c = currentUserData

                console.log(this.server_currentUserData_c.ud_userId_uid)
                // 2) get currentUserCreatedQuest
                serverPre_userDataSub_questPermission_get_withUserId_f({
                    userId_uid: this.server_currentUserData_c.ud_userId_uid,
                    questMinPermission_n : enum_questPermission_n.guide,
                    cb_f : (uds_questPermissions_byId_c) => {

                        this.server_uds_questPermissions_byId_c = uds_questPermissions_byId_c

                        // 2) get quest events
                        this.m_setDisplayMonthQuestEvents_f()

                        obj_forEach_f(uds_questPermissions_byId_c, uds_questPermission_c => {

                            // 3) get quest explore
                            serverBig_questExplore_once_f(uds_questPermission_c.udsqp_questId_uid, false, (questExplore_c) => {
                                if (questExplore_c) {
                                    this.$set(this.server_questsExplore_byQuestId, uds_questPermission_c.udsqp_questId_uid, questExplore_c)
                                }
                            })

                            // 4) add to calendar selected questsId
                            this.calendarSelectedQuestId_a.push(uds_questPermission_c.udsqp_questId_uid)
                        })
                    }
                })

            })
        },
        destroyed(){

            // 1) remove currentUserData
            serverAuth_currentUserData_remove_vl_f(this.$options.name)

            // 2) remove questsEvents listeners
            this.questEventsListenersInfo_a.forEach(questEventListenerInfo_o => {
                server_questEvents_cl_remove_f(this.$options.name, questEventListenerInfo_o.uds_questPermission_c.udsqp_questType_e, questEventListenerInfo_o.uds_questPermission_c.udsqp_questId_uid, questEventListenerInfo_o.firstDayOfTheMonth_t, questEventListenerInfo_o.lastDayOfTheMonth_t)
            })

        },
    }

</script>

<style scoped lang="scss">

    .lc_createEvent{
        position: fixed;
        bottom: 64px;
        right: 12px;
        width: 32px;
        height: 32px;
        background: #501078;
        background: var(--color-purple);
        padding: 8px;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2);
        border-radius: 50%;

        &.lc_laptop{
            bottom: 12px;
        }
    }



</style>
